import { Location } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription, filter, fromEvent, map, pairwise } from 'rxjs';
import { FastAPIService, News, Solver } from 'src/app/service/fast-api.service';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-ai_box',
  templateUrl: './ai_box.component.html',
  styleUrls: ['./ai_box.component.scss']
})
export class Ai_boxComponent implements OnInit {
  results: News[] = [];
  resultsFound: number = 0;
  isHome = false;
  filter = new Solver().solve().filter;
  //will get it at constructor or oninit
  input_text: FormControl = new FormControl("");
  select = "เกี่ยวข้อง"
  showList = true;
  ready: boolean = true;
  input: string | null = null;
  streamData: any[] = []; 
  streamDataStr: string = ''; 
  @Input() notFound: boolean = false;
  
  
  routerSubscribe: Subscription | undefined;

  constructor(private route: ActivatedRoute, private router: Router, private fastService: FastAPIService, private location: Location) {
    this.routerSubscribe = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        //if(event.url.split(';')[0] == '/home/search') this.isHome = true;
        //else  this.isHome = false;
        this.input = this.route.snapshot.paramMap.get('input');
        this.reloadData();
      }
    })
  }

  async reloadData() {
    if(!this.input) this.input = "*";
    this.input_text.setValue(this.input);
    this.results = [];
    this.loadingNews = true;
    this.start = 0;

    this.start += this.rows; 
    this.loadingNews = false;

    
    this.streamData = [];
    this.streamDataStr = '';
    const [dataStream$, configStream$] = this.fastService.getAISearchResult(this.input);
    dataStream$.subscribe({
      next: (data: any) =>{
       // this.streamData.push(data);
        this.streamDataStr += data.data;
      },
      error: (error: any) =>{
        console.error('Error in streaming:',error);
      }
    });
}

  scrollSubscribe: Subscription | undefined;

  ngOnInit(): void {
    this.scrollSubscribe = fromEvent(window, 'scroll').pipe(
      map(() => window.scrollY),
      pairwise(),
      filter(([prev, curr]) => curr > prev)
    ).subscribe(scrollY => {
      if(this.loadingNews || this.results.length >= 30)  return;
      this.checkScrollEnd();
    })
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.scrollSubscribe?.unsubscribe();
    this.routerSubscribe?.unsubscribe();
  }

  loadingNews: boolean = false;
  reachTheEnd: boolean = false;

  async checkScrollEnd() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

    if (windowHeight + scrollTop >= documentHeight - 300 && !this.reachTheEnd) {
      this.onMoreButtonClick();
    }
    
  }

  async onMoreButtonClick() {
    if(this.loadingNews)  return;
    this.loadingNews = true;
    await this.getMoreNews();
    this.loadingNews = false;
  }


  start = 0;
  rows = 10;
  async getMoreNews() {
    this.loadingNews = true;
    
    await this.fastService.getSearchResult(this.input ?? "", this.start, this.rows).then((response) => {
      this.start += this.rows
      if(response.newsList.length) {
        for(let news of response.newsList) {
          this.results.push(news);
        }
      }
      else this.reachTheEnd = true;
    })

    this.loadingNews = false;
  }


}